var map = {
	"./BaseType.js": [
		"549f",
		"chunk-368c9c8c"
	],
	"./HyperPay.js": [
		"df11",
		"chunk-eaa1d446"
	],
	"./MasterCard.js": [
		"a773",
		"chunk-074cbea6"
	],
	"./Noon.js": [
		"4d24",
		"chunk-281cb10d"
	],
	"./Urway.js": [
		"51e2",
		"chunk-de0d6754"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4f0c";
module.exports = webpackAsyncContext;